import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./apiService/allApi";
import App from "./app/App";
import "./assets/css/App.scss";
import "./assets/css/theme-light.css";
import "./assets/css/Loader.css";
import "remixicon/fonts/remixicon.css";
import "react-image-crop/dist/ReactCrop.css";
import "react-image-crop/src/ReactCrop.scss";
ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);
